export const environment = {
  production: false,
  authTokenKey: 'session',
  urlEnv: 'LOCAL',
  public_key: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAqT5nssmkUt7sWmlOgWBW
idF3U9KbFZiGceGb6O0C/LK5XcOqoPYsGLUTciqUwqXix83hys0+lOfte7tWyn6P
FeDADrChxpKKAeOIkEAF0h442Uk2CJBLKCg+i8385xBkDqNiCEQmS/YMMvsU7KEr
m+/3H7h/LVoE0apFrsmBobfpivE4fC6MMtqpzwZ27sQiLM/smFoX4ZWWmwWaj0uv
EoLTndHjT3LCpG1/ObM7KD/SwwsuhRPsrArQ07EFYHk+BvFMOrpFjJmlLr0IPDwP
0WV2g5W1UXQbG96Cy0IDKcrui0hRI47VzoLK3CgXdB3kTALW2Bjgg0LG6vWssXqG
NVx/QLX0mMPTvIDmfSIBK8c5jlLqWcweQ8sLb7gNE9Qt+sri0R9T/GmyR2FmbsjV
Bk/IhtY5wB8V1o5JEXNrJY+MBbabBDipovzyhNviQaYvPSV1gnnl+Ib6wJ9MQ8UM
IxM9ya1dvU1Bs8UyelcEJvuYive1kLYuNsIcteK1lHlEEHAcly3/e0bZ+ElfnVjU
6eAEZD/shkqVsdt6FGRA/8lGDJ7AA/2woO7G5LnxjFc999KmSpISiGUJJlLNGCZq
KeL7YNGhY4PTiDaZqnebscYwva5xmInDIjAHgw2JMR+b78Al1jo5nbj2su7AVRUo
XH8q20Q2FtJer38CeQWO//cCAwEAAQ==
-----END PUBLIC KEY-----`
};